import { render } from "./Articles.vue?vue&type=template&id=08324e1e&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=08324e1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08324e1e"

export default script